<mat-card class="standardized">
    <mat-card-subtitle rtl>
        <span class="widget-title">Valuation Range Estimate
            <a class="infoPopup" *ngIf="!isCSRMode" (click)="openAvmInfoDialog()">
                <fa-icon icon="info-circle"></fa-icon>
            </a>
        </span>
        <br>
        <span *ngIf="!isCSRMode">AVM process date: <strong>{{details.processedDate | date:'MM/dd/yy' }} </strong></span>
        <br>
        <span *ngIf="!isCSRMode">Data Provider: <strong>Quantarium </strong></span>
    </mat-card-subtitle>

    <div class="home-value-section">
        <div class="avm-range">
            <div class="range-value">
                <p><strong>${{details.lowValue | number : '1.0-0'}}</strong></p>
            </div>
            <div class="bar-line"></div>
            <div class="range-value">
                <p><strong>${{details.highValue | number : '1.0-0'}}</strong></p>
            </div>
        </div>
        <div class="home-value-bar btn btn-primary">
        </div>
        <div class="avm-range">
            <div class="range">
                <p>Low</p>
            </div>
            <div class="range">
                <p class="end">High</p>
            </div>
        </div>
    </div>
</mat-card>
